module.exports = __webpack_public_path__ + "img/HA2505-107.75b17540.jpg";